import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import "./AgentTabsView.scss";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { clientRoutes } from "../../../../utils/routes";
import { CommonEnums } from "../../../../enums/common.enums";
import { isAgency } from "../../../../utils/helpers/common";

const AgencyAgentEmployeeTabsView = () => {
  const [value, setValue] = React.useState(0);
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const params: any = useParams();
  let type = searchParams.get("type") || "";
  const location = useLocation();

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    const result: any = userTabs.filter((tab) => tab.id === newValue);

    const base = clientRoutes?.agencyAgentViewEmployee.replace(":id", params?.id);

    navigate(`${base}?type=${result[0]?.slug}`, {
      state: location?.state,
    });
  };

  React.useEffect(() => {
    const result: any = userTabs.filter((tab) => tab.slug === type);
    setValue(result[0]?.id);
  }, [type]);

  return (
    <div className="agent-view-tab-bar-container">
      <Box sx={{ maxWidth: "100%", bgcolor: "background.paper" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
        >
          {userTabs?.map((tab) => {
            if (isAgency()) {
              return <Tab label={tab?.value} key={tab?.id} />;
            } else {
              if (tab?.id === 0) {
                return <Tab label={tab?.value} key={tab?.id} />;
              }
            }
          })}
        </Tabs>
      </Box>
    </div>
  );
};

const userTabs = [
  {
    value: CommonEnums?.agentsTabsType?.info?.value,
    id: 0,
    slug: CommonEnums?.agentsTabsType?.info?.key,
  },

  {
    value: CommonEnums?.agentsTabsType?.permissions?.value,
    id: 1,
    slug: CommonEnums?.agentsTabsType?.permissions?.key,
  },
  {
    value: CommonEnums?.agentsTabsType?.subscription?.value,
    id: 2,
    slug: CommonEnums?.agentsTabsType?.subscription?.key,
  },
];

export default AgencyAgentEmployeeTabsView;
